import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

//anee
// @Injectable({
//   providedIn: 'root'
// })
import { Observable } from 'rxjs';
import { Constants } from '../shared.constants';
import { HeaderService } from '../../core/services/header.service';

@Injectable()
export class BaNotificationService {

  maxNoOfRecords:Number;
  notificationData:any={
    'activeCount':0,
    'notifications':[
      'message',
      'metaData',
      'status'
    ],
    'totalNoOfRecords':0
  } 
  metaData=""
  constructor(private httpClient: HttpClient,private headerService: HeaderService) { }
  setMaxRecords(maxRecords){
    this.maxNoOfRecords = maxRecords;
    
  }
  markAsRead(seqId:any){
    //if(this.serviceUrl){
      let Params = new HttpParams();
      Params = Params.append('id', seqId + "");
      let messageurl: any = Constants.NOTIFICATION_BASE_URL + Constants.NOTIFICATION_API_BASE_URL + "/read";
      let messagesObsv = this.httpClient.get<any>(messageurl, { "params": Params });
       messagesObsv.subscribe((data)=>{
         this.updateUi();
      },(err) =>{
        //console.error("failed to update");
      });
   //}
   
  }

  //anee final
  updateActiveCount(): Observable<any>{
    var url = Constants.NOTIFICATION_BASE_URL + Constants.NOTIFICATION_API_BASE_URL + "/count";
    let messagesObsv = this.httpClient.get<any>(url);
    
    messagesObsv.subscribe((data) => {
      //console.log(JSON.stringify(data));
      this.notificationData.activeCount = data;
      this.headerService.updateBadge('notificationIcon', data);
    }, (err) => {
      //console.error("failed to update active count");
    });

    return messagesObsv;
  }

  //anee final
  updateNotificationUnreadList(pageNumber: Number): Observable<any>{
    let messageurl: any = Constants.NOTIFICATION_BASE_URL + Constants.NOTIFICATION_API_BASE_URL+"?pageNumber=" + pageNumber + "&pageSize=" + this.maxNoOfRecords;
    let messagesObsv = this.httpClient.get<any>(messageurl);
    messagesObsv.subscribe((data) => {
      this.notificationData.notifications = data['notifications'];
      this.notificationData.totalNumberOfRecords = data['totalNoOfRecords'];
      for(var i=0;i<this.notificationData.notifications.length;i++){
        this.metaData = JSON.parse(this.notificationData.notifications[i].metaData);
        this.notificationData.notifications[i].status = this.metaData["status"];
      }
    }, (err) => {
      //console.error("failed to update");
    });
    return messagesObsv;
    
  }
  
  //final
  updateUi(){
    
    this.updateActiveCount();
    this.updateNotificationUnreadList(0);
  }

  //anee
  getAllNotifications(pageNumber,pageSize){
    //let messageurl: any = this.serviceUrl + "/all?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    var url = Constants.NOTIFICATION_BASE_URL + Constants.NOTIFICATION_API_BASE_URL + "/all?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    return this.httpClient.get<any>(url);
    
  }

  //anee
  getPaginatedNotifications(pageNumber,pageSize){
    //let messageurl: any = this.serviceUrl + "/all?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    var url = Constants.NOTIFICATION_BASE_URL + Constants.NOTIFICATION_API_BASE_URL + "/count";
    return this.httpClient.get<any>(url);
   
  }


  //anee
  pushNotification(body:any): Observable<any> {
    var url = Constants.NOTIFICATION_BASE_URL + Constants.NOTIFICATION_API_BASE_URL;
    return this.httpClient.post<any>(url,body);
  }

}
